module.exports = '4.4.2';
// Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/version.js
// module id = 1415
// module chunks = 0